import {Link} from "react-router-dom";
import styles from "./Header.module.css"

export default function Header(){
  return(
  <header className={styles.header}>
    <span className={styles.header_name}><Link to="/" className={styles.name_link}>Daanyal Shareef</Link></span>
    <nav className={styles.header_nav}>
      <ul className={styles.nav_list}>
        <li><Link className={styles.nav_link} to="/">Home</Link></li>
        </ul>
    </nav>
  </header>)//<li><Link className={styles.nav_link} to="/about-me">About Me</Link></li>
      
}